export enum COLORS {
  GRAY = '#D0CFD9',
  BLUE = '#0462FE',
  GREEN = '#29CC78',
  RED = '#FF4D63',
  YELLOW = '#FAC800',
  LIGHT_BLUE = '#60A7FF',
  LIGHT_GREEN = '#77E6A5',
  LIGHT_RED = '#FF99A0',
  CIRCLE_NODE = '#49465C',
  RECT_NODE_DEFAULT = '#F8F8FA',
  RECT_NODE = '#1890ff',
  RECT_TEXT = '#FFFFFF',
  DARK_GREEN = '#19a662',
  DARK_YELLOW = '#e0b300',
  COLOR_F7992D = '#f7992d',
  COLOR_19A662 = '#19a662',
  COLOR_D9324E = '#d9324e',
  COLOR_FBD189 = '#fbd189',
  COLOR_141223 = '#141223',
  COLOR_FFF3D8 = '#fff3d8',
  COLOR_9E76E5 = '#9e76e5',
  COLOR_B397E5 = '#b397e5',
  COLOR_C8B7E5 = '#c8b7e5',
  COLOR_50D0D9 = '#50d0d9',
  COLOR_7CD3D9 = '#7cd3d9',
  COLOR_F27988 = '#f27988',
  COLOR_5A93F2 = '#5a93f2',
  COLOR_93BBFF = '#93bbff',
  COLOR_BACFF2 = '#bacff2',
  COLOR_F29DA8 = '#f29da8',
  COLOR_A5A1BF = '#a5a1bf',
  COLOR_C5C5CB = '#c5c5cb',
  COLOR_7C55F3 = '#7c55f3',
  COLOR_724BE6 = '#724be6',
  COLOR_5628DE = '#5628de',
  COLOR_65E29F = '#65e29f',
  COLOR_15D26D = '#15d26d',
  COLOR_08AC54 = '#08ac54',
  COLOR_069650 = '#069650',
  COLOR_F36A7B = '#f36a7b',
  COLOR_FA8C93 = '#fa8c93',
  COLOR_F64D62 = '#f64d62',
  COLOR_DD041F = '#dd041f',
}

export const modalTypeColor = {
  warning: '#EFBD47',
  error: '#ED6F6F',
  success: '#55D187',
  info: '#1890ff',
}
